import React from "react";
import { Card, CardDescription, CardHeader, CardTitle } from "../ui/Card";
import { EnvelopeClosedIcon } from "@radix-ui/react-icons";

interface EmailConfirmationProps {
  email: string;
  type?: "signup" | "password-reset";
}

export const EmailConfirmation: React.FC<EmailConfirmationProps> = ({
  email,
  type = "password-reset",
}) => {
  const isSignup = type === "signup";

  return (
    <Card className="w-full max-w-sm bg-white/95 backdrop-blur-sm shadow-none border-0 ">
      <CardHeader className="text-center space-y-4 pb-6 pt-8">
        <div className="mx-auto w-16 h-16 rounded-none flex items-center justify-center">
          <EnvelopeClosedIcon className="h-8 w-8 text-primary-blue" />
        </div>
        <CardTitle className="text-2xl font-semibold indigo-dark">
          {isSignup ? "Check your Email" : "Password Reset"}
        </CardTitle>
        <CardDescription className="text-gray-600">
          {isSignup ? (
            <>
              We've sent a verification email to{" "}
              <span className="font-medium indigo-dark">{email}</span>. Please check your inbox and
              click the verification link to continue.
            </>
          ) : (
            <>
              We've sent a reset password mail to{" "}
              <span className="font-medium indigo-dark">{email}</span>. Please enter it below to
              continue
            </>
          )}
        </CardDescription>
      </CardHeader>
    </Card>
  );
};
